import React from 'react';
import { useEffect, useState } from "react";
import { useAppDispatch } from "redux/hooks";

import { setIsAuthenticated } from 'redux/pages/Login/loginSlice';

const PrivateRoute = (props: { children: React.ReactNode }): JSX.Element => {
  const { children } = props;
  const dispatch = useAppDispatch();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("accesstoken");
    if (!token) {
      window.location.href = "/api/v1/auth/signin";
    } else {
      dispatch(setIsAuthenticated(true));
      setIsReady(true);
    }
  }, [dispatch]);

  if (!isReady) return <></>;

  return <>{children}</>;
};

export default PrivateRoute;
